var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.625C6.03333 20.625 5.646 20.471 5.338 20.163C5.02933 19.8543 4.875 19.4667 4.875 19V7.625H5.875V19C5.875 19.15 5.94167 19.2917 6.075 19.425C6.20833 19.5583 6.35 19.625 6.5 19.625H14.875V20.625H6.5ZM9.5 17.625C9.03333 17.625 8.646 17.471 8.338 17.163C8.02933 16.8543 7.875 16.4667 7.875 16V5.225C7.875 4.775 8.02933 4.39567 8.338 4.087C8.646 3.779 9.03333 3.625 9.5 3.625H17.275C17.725 3.625 18.1043 3.779 18.413 4.087C18.721 4.39567 18.875 4.775 18.875 5.225V16C18.875 16.4667 18.721 16.8543 18.413 17.163C18.1043 17.471 17.725 17.625 17.275 17.625H9.5ZM9.5 16.625H17.275C17.425 16.625 17.5627 16.5583 17.688 16.425C17.8127 16.2917 17.875 16.15 17.875 16V5.225C17.875 5.075 17.8127 4.93733 17.688 4.812C17.5627 4.68733 17.425 4.625 17.275 4.625H9.5C9.35 4.625 9.20833 4.68733 9.075 4.812C8.94167 4.93733 8.875 5.075 8.875 5.225V16C8.875 16.15 8.94167 16.2917 9.075 16.425C9.20833 16.5583 9.35 16.625 9.5 16.625ZM8.875 16.625V4.625V16.625Z",
    fill: "#4D5761"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.b7bde3f8454e4601db95adb9a6ca9809.svg";
export { ForwardRef as ReactComponent };